import {Owner, RegisteredUser, RoleId, Team, TeamId, TeamMin} from "platformed-client/types";
import {declareDialog} from "../../components/dialogs";
import {ConfirmationDialogProps} from "./ConfirmationDialog";

type ReassignDialogProps = {onReassign: (owner?: Owner) => Promise<unknown>};

export const confirmationDialog = declareDialog<ConfirmationDialogProps>();
export const signOutDialog = declareDialog();
export const reassignUserDialog = declareDialog<ReassignDialogProps>();
export const reassignTeamDialog = declareDialog<ReassignDialogProps>();
export const inviteUserDialog = declareDialog<{
  initialName?: string;
  initialEmail?: string;
  onInvite?: (user: RegisteredUser) => Promise<unknown>;
}>();
export const createEditTeamDialog = declareDialog<{
  type: "Create" | "Edit";
  initialName?: string;
  team?: Team;
  onCreate?: (team: TeamMin) => Promise<unknown>;
}>();
export const addRoleMemberDialog = declareDialog<{roleId: RoleId}>();
export const addTeamMemberDialog = declareDialog<{teamId: TeamId}>();
